import React, { useState } from "react";
import { ReactComponent as Paw } from "../assets/paw.svg";
import {  useHistory } from "react-router-dom";


const CatCard = ({ cat, props }) => {

 
  const { id, name, image, description } = cat;
  const h = useHistory();

  const takeCat=id => {
    h.push(`/cat?id=${id}`)
  }
  return (
    <li className="list-item">
      <div className="list-content">
        <div className="header">
          <div className="catImage">
          <img src={image} alt="cat" />
          {/* <div className="topleft"> <img src='/smiley.svg' alt="cat" />Best</div> HERE FOR THE TAGS*/}
          </div>
          <h3>{name}</h3>
          <p>{description}</p>
        </div>
        <div className="content">
          <div className="btn" onClick={ () => takeCat(id) }>
            <Paw />
          </div>
        </div>
        <button className="btn btn--block card__btn">Take me home</button>
     
      </div>
    </li>
  );
};

export default CatCard;
